'use client'

import { useState, useEffect } from 'react'
import { readCookieConsent, writeCookieConsent } from '@/lib/cookie-consent'

export function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // localStorage is browser-only and unavailable during SSR, so this must run after mount.
    if (!readCookieConsent(window.localStorage)) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setVisible(true)
    }
  }, [])

  function accept() {
    writeCookieConsent(window.localStorage, 'all')
    setVisible(false)
  }

  function acceptEssential() {
    writeCookieConsent(window.localStorage, 'essential')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      className="cookie-banner fixed bottom-0 left-0 right-0 z-50 px-4 py-4 sm:py-5"
      style={{ backgroundColor: '#050E1A', borderTop: '1px solid rgba(255,255,255,0.08)' }}
      role="region"
      aria-live="polite"
      aria-label="Informacja o plikach cookie"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Używamy plików cookie, aby zapewnić prawidłowe działanie sklepu i analizować ruch.{' '}
            <a href="/polityka-prywatnosci" className="underline hover:text-white transition-colors" style={{ color: 'rgba(255,255,255,0.75)' }}>
              Polityka prywatności
            </a>
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={acceptEssential}
            aria-label="Akceptuj tylko niezbędne pliki cookie"
            className="px-4 py-2 rounded-lg text-sm transition-colors hover:text-white"
            style={{ color: 'rgba(255,255,255,0.65)', border: '1px solid rgba(255,255,255,0.12)' }}
          >
            Tylko niezbędne
          </button>
          <button
            onClick={accept}
            aria-label="Akceptuję wszystkie — akceptuj wszystkie pliki cookie"
            className="px-5 py-2 rounded-lg text-sm font-semibold transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#1FB8B0', color: '#03080F' }}
          >
            Akceptuję wszystkie
          </button>
        </div>
      </div>
    </div>
  )
}
